import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';
import { IPurchaseOrder } from '../master/models/purchaseorder.model';

@Injectable({ providedIn: 'root' })
export class PurchaseOrderService {
  public selectedPurchaseOrder: IPurchaseOrder = null;
  constructor(private _http: HttpClient) { }
  public fetchPurchaseOrderEntries(): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH);
  }

  // public getDashboardKpis(branchKey?: number | null): Observable<any> {
  //   let url = `${environment.apiBase}/dashboard/purchase/kpis`; // Make sure this matches your Java controller!
  //   if (branchKey !== undefined && branchKey !== null) {
  //     url += `?branchId=${branchKey}`;
  //   }
  //   return this._http.get<any>(url);
  // }

  public getPendingPurchaseOrderCount(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/pending-count`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  public getPendingPurchaseOrderTotalCount(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/pending-count-all`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  public getPurchaseOrderPoInvoiceCountDifference(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/po-invoice/count-difference`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  public getPurchaseOrderPoGrCountDifference(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/po-gr/count-difference`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  public getTopProductsPurchased(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/top-products`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  public getTopSites(branchKey?: number): Observable<any> {
    let url = `${environment.apiBase}/purchaseorder/top-sites`;
    if (branchKey !== undefined && branchKey !== null) {
      url += `?branchKey=${branchKey}`;
    }
    return this._http.get<any>(url);
  }

  // getPurchaseOrdersByPageCount(params = {}): Observable<any> {
  //   return this._http.get<any>(`${environment.apiBase}/purchaseorder/all-by-pagination`,{ params });
  // }

  getPurchaseOrdersByPageCount(params: any = {}, yearKey?: string): Observable<any> {
    const finalParams = yearKey ? { ...params, key: yearKey } : params;
    return this._http.get<any>(`${environment.apiBase}/purchaseorder/all-by-pagination`, { params: finalParams });
  }

  public createPurchaseOrderEntry(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.PURCHASE_ORDER.CREATE, payload);
  }
  public updatePurchaseOrderEntry(payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.UPDATE(payload.purchaseOrderId), payload);
  }

  public getPrintData(id: BigInteger | number): Observable<any> {
  return this._http.get<any>(`${environment.apiBase}/purchaseorder/get-print-data`, {
    params: { id: id.toString() }
  });
}
  // users
  getAllUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/api/user/getall`);
  }
  public fetchPOById(id): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_BY_ID(id));
  }

  public fetchDetailsByIdForGRN(id): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_DETAILS_BY_ID(id));
  }

  getAllTerms() {
    return this._http.get<any>(BASE_URL + END_POINTS.TERMS.FETCH);
  }
  getAllTermsByType(type:string) {
    return this._http.get<any>(BASE_URL + END_POINTS.TERMS.FETCH_BY_TYPE(type));
  }
  fetchPurchaseOrderBySupplier(supplierKey): Observable<any>{
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_BY_SUPPLIER(supplierKey));
  }
  public approvePO(id: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.APPROVE(id), {});
  }

  public rejectPO(poId: any, payload): Observable<any> {
      return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.REJECT(poId), payload);
  }

  public forceClose(poId: any, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.FORCECLOSE(poId), payload);
  }

  public printPO(id: number){
    return this._http.get(BASE_URL + END_POINTS.PURCHASE_ORDER.PRINT(id), { responseType: 'blob' });
  }

  public fetchPOForDO(siteKey): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_FOR_DO+ '?'+siteKey);
  }

  public fetchPOSitesForDO(): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_SITE_FOR_DO);
  }

  public fetchProductsForDO(params): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_PRODUCT_FOR_DO+ '?' + params);
  }


  getMakesByProduct(productKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/product/${productKey}/makes`);
  }

  getGodownStockByProduct(productKey: any, makeKey: any, warehouseKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/stock/getStockByProduct`, {
      params: { productKey, makeKey, warehouseKey }
    });
  }

  cancelPO(purchaseOrderKey: number, reason: string): Observable<any> {
    return this._http.put<any>(
      `${environment.apiBase}/purchaseorder/${purchaseOrderKey}/cancel`,
      { reason }
    );
  }

  getSuppliers(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/supplier-advance-payment/suppliers`);
  }

  getPOsBySupplier(supplierKey: any): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/supplier-advance-payment/po-by-supplier`, {
      params: { supplierKey },
    });
  }

  getPurchaseOrderStatus(purchaseOrderId: number) {
  return this._http.get<any>(
    `${environment.apiBase}/purchaseorder/status/${purchaseOrderId}`
  );
}

  getPODetails(poKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/supplier-advance-payment/po-details`, {
      params: { poKey },
    });
  }

  createAdvancePaymentRequest(dto: any, attachment: File | null): Observable<any> {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(dto)], { type: 'application/json' }));
    if (attachment) {
      formData.append('attachment', attachment);
    }
    return this._http.post(`${environment.apiBase}/supplier-advance-payment/create`, formData);
  }

  getAdvanceRequestStatus(poKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/supplier-advance-payment/status`, {
      params: { poKey },
    });
  }

  getAdvanceRequestDetails(poKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/supplier-advance-payment/details`, {
      params: { poKey },
    });
  }

  downloadPreviewFromS3(key: string) {
    return this._http.get(
      environment.apiBase + '/documents/downloadPreview?key=' + encodeURIComponent(key),
      { responseType: 'blob' }
    );
  }

    
}